import React from 'react';
import { createSvgIcon } from '@mui/material';
export default createSvgIcon(React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0ZM6.65262 14.5L6 13.9114L12 8.5L18 13.9114L17.3474 14.5L12 9.67719L6.65262 14.5Z" // eslint-disable-line
 }), 'ChevronUpFilled');
